import { useEffect } from "react";
import { useParams } from "react-router-dom";

import useService from "../../../../hooks/useService";
import { case_fee_schedule } from "../../../api/endpoints/case";
import { useSettlementStore } from "../store/settlementStore";

export default function useFetchCaseDetails() {
  const { id } = useParams();
  const caseRepository = useService("repositories/case-repository");
  const caseDetail = useSettlementStore((state) => state.caseDetail);
  const feeSchedule = useSettlementStore((state) => state.feeSchedule);
  const refreshVersion = useSettlementStore((state) => state.refreshVersion);
  const setFeeScheduleLoading = useSettlementStore((state) => state.setFeeScheduleLoading);
  const setCaseDetail = useSettlementStore((state) => state.setCaseDetail);
  const setFeeSchedule = useSettlementStore((state) => state.setFeeSchedule);
  const reset = useSettlementStore((state) => state.reset);

  useEffect(() => {
    let active = true;

    async function fetchCaseDetails() {
      if (!id || id === "undefined") {
        if (active) {
          reset();
        }
        return;
      }

      try {
        if (active) {
          setFeeScheduleLoading(true);
        }
        const [data, feeScheduleData] = await Promise.all([
          caseRepository.findRecord(id, { noCache: true }),
          case_fee_schedule.retrieve(id).catch(() => null),
        ]);
        if (active) {
          setCaseDetail(data);
          setFeeSchedule(feeScheduleData);
        }
      } catch (error) {
        if (active) {
          reset();
        }
      } finally {
        if (active) {
          setFeeScheduleLoading(false);
        }
      }
    }

    fetchCaseDetails();

    return () => {
      active = false;
    };
  }, [
    caseRepository,
    id,
    refreshVersion,
    reset,
    setCaseDetail,
    setFeeSchedule,
    setFeeScheduleLoading,
  ]);

  return { caseDetail, feeSchedule };
}
